<template>
    <div class="modal fade selectproductpopup-custom" id="newProductsModal">
        <div class="modal-dialog" style="max-width: 1140px !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Select Products</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body" v-if="order !=null">
                    <!-- fieldsets -->
                    <fieldset class="search">
                        <div class="row">
                            <div class="col-sm-6 col-md-6">
                                <form class="form-inline" action="" @submit.prevent="search()">
                                    <div class="autocomplete-form">
                                        <autocomplete
                                            :source="productSearchEndpoint"
                                            :requestHeaders="authHeaders"
                                            :resultsFormatter="resultsFormatter"
                                            :resultsDisplay="formattedDisplay"
                                            :name="'filter_data'"
                                            :initialDisplay="initialDisplay"
                                            ref="autocomplete"
                                            placeholder="Quick Search"
                                            input-class="form-control"
                                            @input="inputFilterProduct($event)"
                                            @selected="selectFilterProduct($event)"
                                            @clear="selectFilterProduct(null)"
                                        />
                                    </div>
                                </form>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="addbtn-popup">
                                    <button type="button" class="btn btn-primary close-modal" v-on:click="addProducts"
                                    :class="{'disabled': this.loading == true || this.products.length == 0}">Add to Sales Order
                                    </button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div class="selectproduct-popupheight">
                    <Products v-if="isNewProductsModal"
                        :customer_id="order.customer_id" :selectedProducts="selectedProducts" :search_filter="search_filter"
                        :quantityUnits="quantityUnits"
                        :exclude_products="exclude_products"
                        :products="products"
                        @selectProduct="selectProduct($event)"
                        @watchChangedProducts="watchChangedProducts($event)"  :bus="bus" ref="productsList"
                    ></Products>
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary close-modal" v-on:click="addProducts"
                            :class="{'disabled': this.loading == true || this.products.length == 0}">Add to Sales Order
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import Products from "./Products";
import Autocomplete from "./Autocomplete";
import Vue from "vue";

export default {
    name: "SelectProductsModal",
    props: ['order', 'exclude_products', 'quantityUnits', 'isNewProductsModal'],
    components: {
        Products, Autocomplete
    },
    created() {

    },
    mounted() {

    },
    data() {
        return {
            bus: new Vue(),
            search_filter: null,
            selectedProducts: [],
            products: [],
            initialDisplay: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        addProducts(){
            this.$emit('selectProducts', {products: this.products, selectedProducts: this.selectedProducts});
            this.products = [];
            this.selectedProducts = [];
        },
        selectProduct(event) {
            if(event.c) {
                if(this.selectedProducts.includes(event.c.id)) {
                    if(event.checked == false) {
                        this.selectedProducts.splice(this.selectedProducts.indexOf(event.c.id), 1);
                    }
                } else {
                    this.selectedProducts.push(event.c.id);
                }

                if(this.products.includes(event.c)) {
                    if(event.checked == false) {
                        this.products = this.products.filter((x) => x.product_id == event.c.id);
                    }
                } else {
                    let product = _.cloneDeep(event.c);
                    product.product_id = event.c.id;
                    product.quantity = event.c.qty;
                    product.id = null;
                    this.products.push(product);
                }
            }
            this.products = this.products.filter((x) => this.selectedProducts.includes(x.product_id));
        },
        inputFilterProduct(event){
        },
        selectFilterProduct(event) {
            //console.log(event);

            this.search_filter = event != null && event.selectedObject ? event.selectedObject.name : '';
            this.initialDisplay = this.search_filter;

            setTimeout(() => {
                this.search_filter = event != null && event.selectedObject ? event.selectedObject.name : '';
                this.search();
            }, 500);
        },
        productSearchEndpoint(input) {
            return window.route('so.products.search', {page: 1, per_page: 20, search_filter: input});
        },
        search() {
            this.bus.$emit('getProducts')
        },
        resultsFormatter(result) {
            // console.log(result)
            if (!result.errorMessage && result.data.products.data.length) {
                let products = [];
                result.data.products.data.forEach((x) => {
                    const div = document.createElement('div')
                    div.innerHTML = x.product_desc
                    let description = div.textContent || div.innerText || ''

                    /*if(description.length > 150) {
                        description = description.substring(0, 150)+"..."
                    }*/

                    let product_num = '';
                    if(x.product_num) {
                        product_num = `#${x.product_num}`
                    }

                    products.push({
                        id: x.id,
                        name: x.product_name,
                        description: `<div class="autocomplete-item"><div class="prod-number">${product_num}</div><div class="prod-name">${x.product_name}</div> <div class="description"> ${description}</div></div>`
                    });
                });

                return products;
            }
            return [];
        },
        formattedDisplay(result) {
            //return result.name + ' [' + result.id + ']'
            return result.description;
        },
        watchChangedProducts(products) {
            products.forEach((x) => {
                let prodIndex = this.products.findIndex((y) => y.product_id == x.id);
                if(prodIndex > -1) {
                    this.products[prodIndex].product_num = x.product_num;
                    this.products[prodIndex].product_desc = x.product_desc;
                    this.products[prodIndex].product_name = x.product_name;
                    this.products[prodIndex].qty = x.qty;
                    this.products[prodIndex].quantity = x.qty;
                    this.products[prodIndex].price = x.price;
                    this.products[prodIndex].unit_price = x.price;
                    this.products[prodIndex].uom = x.uom;
                    this.products[prodIndex].cost = x.cost;
                }
            });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ]),
        authHeaders() {
            return {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        },
    }
}
</script>

<style scoped>

</style>
